import api from '@/api/features';

const actions = {
  async FETCH_FEATURES({ commit, state }) {
    if (state.features && Object.keys(state.features).length > 0) {
      return state.features;
    }

    const { command_center_features: features } = await api.fetchFeatures();

    commit('SET_FEATURES', features);

    return features;
  },

  async FETCH_FEATURE_CONFIGURATIONS({ commit, state }) {
    if (Array.isArray(state.featuresAvailable) && state.featuresAvailable.length > 0) {
      return state.featuresAvailable;
    }

    const { results: featureConfigurations } = await api.fetchFeatureConfigurations();

    if (!Array.isArray(featureConfigurations) || featureConfigurations.length === 0) {
      return [];
    }

    const featuresAvailable = [];

    featureConfigurations.forEach(featureConfig =>
      featuresAvailable.push(...featureConfig.features.map(feature => feature.slug)),
    );
    // featuresAvailable should be cast to a Set here to make elements unique

    commit('SET_AVAILABLE_FEATURES', featuresAvailable);

    return featuresAvailable;
  },
};

export default actions;
